var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculatorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_124044",
    "data-name": "Group 124044",
    transform: "translate(-305 -247)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_267",
    "data-name": "Ellipse 267",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(305 247)",
    fill: "#1b4a83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-accounting",
    "data-name": "Icon map-accounting",
    d: "M13.986.72H4.754A1.157,1.157,0,0,0,3.6,1.874v11.54a1.157,1.157,0,0,0,1.154,1.154h9.232a1.157,1.157,0,0,0,1.154-1.154V1.874A1.157,1.157,0,0,0,13.986.72ZM7.062,12.26a.579.579,0,0,1-.577.577H5.331a.579.579,0,0,1-.577-.577v-.289a.579.579,0,0,1,.577-.577H6.485a.579.579,0,0,1,.577.577Zm0-2.308a.579.579,0,0,1-.577.577H5.331a.579.579,0,0,1-.577-.577V9.664a.579.579,0,0,1,.577-.577H6.485a.579.579,0,0,1,.577.577Zm0-2.308a.579.579,0,0,1-.577.577H5.331a.579.579,0,0,1-.577-.577V7.356a.579.579,0,0,1,.577-.577H6.485a.579.579,0,0,1,.577.577Zm3.462,4.616a.579.579,0,0,1-.577.577H8.793a.579.579,0,0,1-.577-.577v-.289a.579.579,0,0,1,.577-.577H9.947a.579.579,0,0,1,.577.577Zm0-2.308a.579.579,0,0,1-.577.577H8.793a.579.579,0,0,1-.577-.577V9.664a.579.579,0,0,1,.577-.577H9.947a.579.579,0,0,1,.577.577Zm0-2.308a.579.579,0,0,1-.577.577H8.793a.579.579,0,0,1-.577-.577V7.356a.579.579,0,0,1,.577-.577H9.947a.579.579,0,0,1,.577.577Zm3.462,4.616a.579.579,0,0,1-.577.577H12.255a.579.579,0,0,1-.577-.577v-.289a.579.579,0,0,1,.577-.577h1.154a.579.579,0,0,1,.577.577v.289Zm0-2.308a.579.579,0,0,1-.577.577H12.255a.579.579,0,0,1-.577-.577V9.664a.579.579,0,0,1,.577-.577h1.154a.579.579,0,0,1,.577.577v.289Zm0-2.308a.579.579,0,0,1-.577.577H12.255a.579.579,0,0,1-.577-.577V7.356a.579.579,0,0,1,.577-.577h1.154a.579.579,0,0,1,.577.577v.289Zm0-2.6a.579.579,0,0,1-.577.577H5.331a.579.579,0,0,1-.577-.577V2.74a.579.579,0,0,1,.577-.577h8.078a.579.579,0,0,1,.577.577Z",
    transform: "translate(309.271 253.855)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorIcon);
export default __webpack_public_path__ + "static/media/calculatorIcon.8544a39a1664d987d1b5a5451f57b21f.svg";
export { ForwardRef as ReactComponent };